<template>
  <div class="networking-empty-price">
    <slot>
      <span v-html="costDisabledReason" />
      <vz-button
          v-if="preset.typeId"
          big
          variant="primary"
          class="mt-20 mx-auto"
          @click="openFeedbackModal"
      >
        Запрос на расчет
      </vz-button>
    </slot>
  </div>
</template>

<script setup lang="ts">
import {useOrderStore} from "~/stores/order";
import {storeToRefs} from "pinia";
import {VzDialogPreset} from '~/types/types';

const props = defineProps({

})

const { $showDialog } = useNuxtApp()
const { costDisabledReason, isArmeniaLocationDisabled, isGeorgiaLocationDisabled, orderForm } = storeToRefs(useOrderStore())

const preset = computed(() => {
  const result: VzDialogPreset = {
    typeId: '',
    isShort: true,
    additionalFormData: {
      dispatchLocation: orderForm.value.directions.dispatch.locationGuid,
      destinationLocation: orderForm.value.directions.destination.locationGuid,
    }
  }
  if (isGeorgiaLocationDisabled.value) {
    result.typeId = '4f582378-fa25-11ee-b1a1-0cc47a3455a3'
    result.message = 'Грузоперевозки Грузия'
  }
  if (isArmeniaLocationDisabled.value) {
    result.typeId = '4f582377-fa25-11ee-b1a1-0cc47a3455a3'
    result.message = 'Грузоперевозки Армения'
  }
  return result
})

function openFeedbackModal(): void {
  $showDialog({ name: 'feedback', preset: preset.value })
}
</script>

<style lang="scss" scoped>

</style>